const o = {
  supple_reason: '',
  eco_doc_date: '',
  eco_doc_num: '',
  eco_doc_upload_files: [],
  meet_date: '',
  meet_num: '',
  meet_doc_upload_files: [],
  supple_date: '',
  supple_doc_num: '',
  supple_doc_upload_files: [],
  supple_desc: '[]',
  other_event: '[]',
};
export default o;
